import { Link, Button } from '@pg-web/bearded-dragon-ui';
import { paths } from '@pg-web/bearded-dragon-ui';
import { useNavigate } from 'react-router-dom';
import { FallbackProps } from 'react-error-boundary';

const AUTH_ERROR = {
  HEADER: 'Invalid request',
  BODY: (
    <>
      There was an error processing your request. <br /> Check your link and
      make sure you are authorized to access this page.
    </>
  ),
};

const TEXT_MAP: Record<string, Record<string, React.ReactNode>> = {
  '401': AUTH_ERROR,
  '403': AUTH_ERROR,
  DEFAULT: {
    HEADER: 'Oops! Something went wrong',
    BODY: `We are sorry, but we encountered an error. Please click the button to go back and try again.`,
  },
};

export function ErrorFallback(props: any) {
  const { error } = props as FallbackProps;
  const responseStatus = error?.response?.status.toString();

  const navigate = useNavigate();
  return (
    <div className="w-full h-screen flex justify-center items-center p-8">
      <div className="max-w-3xl w-full flex flex-col gap-2 text-center justify-center items-center">
        <p className="font-bold text-xl text-peony">
          {TEXT_MAP?.[responseStatus]?.HEADER || TEXT_MAP.DEFAULT.HEADER}
        </p>
        <p className="text-lg font-sans">
          {TEXT_MAP?.[responseStatus]?.BODY || TEXT_MAP.DEFAULT.BODY}
        </p>
        <Button className="mt-4" onClick={() => navigate(-1)}>
          Go back
        </Button>
        <Link href={paths.home.getHref()} size="lg">
          Go to homepage
        </Link>
      </div>
    </div>
  );
}
